export default "__VITE_ASSET__DZl9bIQp__"